export const GE_URL = 'https://api.rsbuddy.com/grandExchange'


// WEBPACK FOOTER //
// ./src/ui/item/functions/constants.js